import React from 'react';
import styles from './Footer.css';

const Footer = () => {
  const logoPath = '/img/logo.svg'; 

  return (
    <footer className='footer'>
      <div className='footerContent'>
        {/* Column 1: Logo and Description */}
        <div className='footerColumn'>
          <img src={logoPath} alt="Zambia Coat of Arms" className='logo' width='100px'/>
          <p className='description'>
           <b>E-Service Portal</b><br />
            Smart Zambia Institute<br />
                e-Government Division
                
          </p>
        </div>

        {/* Column 2: Useful Links */}
        <div className='footerColumn'>
          <h3 className='columnTitle'>Useful Links</h3>
          <hr className='separator' />
          <ul className='linkList'>
            <li><a href="https://eservices.gov.zm/#/service-directory">Public Service Portal</a></li>
            <li><a href="https://eservices.gov.zm/#/about">About</a></li>
            <li><a href="https://eservices.gov.zm/#/help">Help</a></li>
            <li><a href="https://eservices.gov.zm/#/faq">FAQ</a></li>
            <li><a href="https://eservices.gov.zm/#/terms-and-conditions">Terms and Conditions</a></li>
          </ul>
        </div>

        {/* Column 3: Contacts */}
        <div className='footerColumn'>
          <h3 className='columnTitle'>Contacts</h3>
          <hr className='separator' />
          <div className='contactInfo'>
            <p className='contactLabel'>Phone:</p>
            <p>
              <a href="tel:+260211428600">+260 211 428 600</a>
              <br />
              <span className='shortCode'>(short code: 2000)</span>
            </p>
            <p className='contactLabel'>Email:</p>
            <p>
              <a href="mailto:info@eservices.gov.zm">info@eservices.gov.zm</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;